import React from 'react';
import TextInput, {
  filterNumericKeyPress,
  generatePhoneNumberHandler,
} from '../../../components/TextInput';

export default function PrefillPhoneInput(props) {
  return (
    <TextInput
      name="phone"
      label="Mobile Phone"
      validationData={props.validations}
      formData={props.formData}
      onChange={generatePhoneNumberHandler(props.onChange, props.formData.phone)}
      type="tel"
      pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
      maxLength="12"
      helpText="###-###-####"
      required
      onKeyPress={filterNumericKeyPress}
    />
  );
}
